module.exports = __webpack_public_path__ + "img/folder.ebde98cb.svg";